// Rounded-corner spotlight hole (Sandy 2026-07-20). The dim/blur layer is one
// full-viewport element; this returns a CSS alpha mask that carves a rounded
// rect out of it (evenodd path: viewport minus the hole), so the un-dimmed
// window has the same rounded corners as the app's cards. Recomputed whenever
// the measured rect changes.
export const SPOT_RADIUS = 14;

export function spotlightMaskStyle(rect, radius = SPOT_RADIUS) {
  if (!rect) return {};
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const r = Math.max(0, Math.min(radius, rect.w / 2, rect.h / 2));
  const { x, y, w, h } = rect;
  const d = [
    `M0 0H${vw}V${vh}H0Z`,
    `M${x + r} ${y}`,
    `h${w - 2 * r}`,
    `a${r} ${r} 0 0 1 ${r} ${r}`,
    `v${h - 2 * r}`,
    `a${r} ${r} 0 0 1 -${r} ${r}`,
    `h-${w - 2 * r}`,
    `a${r} ${r} 0 0 1 -${r} -${r}`,
    `v-${h - 2 * r}`,
    `a${r} ${r} 0 0 1 ${r} -${r}`,
    'Z',
  ].join('');
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${vw}" height="${vh}"><path fill-rule="evenodd" d="${d}" fill="white"/></svg>`;
  const url = `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
  return { WebkitMaskImage: url, maskImage: url };
}
